import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';

import { theme } from '@garnish/constants';

import { VStack } from '../../../../../Stack';

// ─────────────────────────────────────────────────────────────────────────────

export const NavbarFloatingPopupFooter = (props: Props) => {
  const { children } = props;

  return (
    <VStack gap={0} style={styles.container}>
      {children}
    </VStack>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
    borderTopWidth: 1,
    borderTopColor: theme.colors.WHITE,
    paddingTop: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren;
